import styled from 'styled-components';
import Colors from '../../styles/theme/colors';
import BackgroundImage from '../../assets/logo-symbol.svg';
import { devices } from '../../styles/theme/devices';
import spaces from '../../styles/theme/spaces';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;

  @media ${devices.laptop} {
    background-attachment: fixed;
    background-image: url(${BackgroundImage});
    background-position: -490px 160px;
    background-repeat: no-repeat;
  }
`;

const Card = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${Colors.default.white};
  border: 1px solid ${Colors.default.lightGrey};
  padding: ${spaces.medium};
  max-width: 424px;
`;

const FormContainer = styled.div`
  width: 100%;
`;

const LinkContainer = styled.div`
  margin-top: ${spaces.xs};
`;

export {
  Container,
  Card,
  FormContainer,
  LinkContainer,
};
